/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function deleteLeaseTemplate (id: number) {
  return rest.delete(`/api/lease-templates/${id}`)
}

export function fetchLeaseTemplate (id: number): Promise<LeaseTemplate> {
  return rest.get(`/api/lease-templates/${id}`)
    .then((resp) => resp.json())
}

export function findManyLeaseTemplates (params?: Record<string, any>): Promise<HalDocument<{
  leaseTemplates: LeaseTemplate[]
}>> {
  return rest.get(`/api/lease-templates?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchLeaseTemplate (id: number, data: Partial<LeaseTemplate>) {
  return rest.patch(`/api/lease-templates/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postLeaseTemplate (data: Partial<LeaseTemplate>) {
  return rest.post('/api/lease-templates', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postLeaseTemplateFile (file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return rest.post('/api/lease-templates', { body: fd })
    .then((resp) => resp.json())
}

export function putLeaseTemplateFile (templateId: number, file: File) {
  const fd = new FormData()
  fd.append('file', file)
  return rest.put(`/api/lease-templates/${templateId}/file`, { body: fd })
    .then((resp) => resp.json())
}
